module.exports = __webpack_public_path__ + "img/chevron-down.ab6879e5.svg";